exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".key {\n  min-width: 68px;\n  height: 66px;\n  border: 1px solid #9A9A9A;\n  border-radius: 8px;\n  text-align: center;\n  margin: 2px; }\n\n.key-value {\n  margin-top: 3px;\n  font-size: 36px;\n  padding: 10px;\n  color: #9A9A9A; }\n\n:host {\n  display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/shared/key/key.component.scss
// module id = ../../../../../src/app/shared/key/key.component.scss
// module chunks = main